declare global {
  interface Window {
    userToken?: string;
    terms?: Record<TermId, Term>;
    links?: Record<LinkId, Link>;
    refs?: Record<ReferenceId, Reference>;
  }
}

export type ElementTag =
  | "p"
  | "paragraph"
  | "text"
  | "em"
  | "italic"
  | "bold"
  | "strong"
  | "term"
  | "web-link"
  | "ref"
  | "br"
  | "doc";

export type TextElement = [
  ElementTag?,
  Record<string, any>?,
  (string | TextElement)?
];

// TODO: is this name correct?
export enum ElementType {
  Link = "Link",
  Reference = "Reference",
  Term = "Term",
}

export type GuidanceOrExample = {
  order_number: number;
  content: StepContent;
  frontId: string;
  type: "guidances" | "examples";
  possible_answer_id?: string;
  guidance_id?: string;
  example_id?: string;
};

export type TermId = string;

export type Term = {
  term_id: TermId;
  description: string;
  name: string;
  party_id?: string;
};

export type LinkId = string;

export type Link = {
  link_id: LinkId;
  description: string;
  name: string;
  address: string;
  party_id?: string;
};

export type ReferenceId = string;

export type Reference = {
  reference_id: ReferenceId;
  description: string;
  code: string;
  link: string;
  party_id?: string;
};

export type Style = {
  color1: string;
  color2: string;
  color3: string;
  color4: string;
  color5: string;
  color6: string;
  logo: string;
};

export type UserProgress = {
  user_id: string;
  module_id: string;
  name: string;
  data: string;
  user_progress_id: string;
};

export type Mark = {
  type: ElementTag;
  attrs: Record<string, string>;
};

export type StepContent = {
  type?: ElementTag;
  content?: StepContent[];
  text?: string | TextElement[];
  marks?: Mark[];
};

export type Direction = { op: Operation; pos: number };

export type Operation = "or" | "and" | "not";
export type InviteAction = "accept" | "reject";
